export const SHOW_REGIONS = [
  // EU Countries
  'Europe/Vienna', // Austria
  'Europe/Brussels', // Belgium
  'Europe/Sofia', // Bulgaria
  'Europe/Zagreb', // Croatia
  'Asia/Nicosia', // Cyprus
  'Europe/Prague', // Czechia
  'Europe/Copenhagen', // Denmark
  'Europe/Tallinn', // Estonia
  'Europe/Helsinki', // Finland
  'Europe/Paris', // France
  'Europe/Berlin', // Germany
  'Europe/Athens', // Greece
  'Europe/Budapest', // Hungary
  'Europe/Dublin', // Ireland
  'Europe/Rome', // Italy
  'Europe/Riga', // Latvia
  'Europe/Vilnius', // Lithuania
  'Europe/Luxembourg', // Luxembourg
  'Europe/Malta', // Malta
  'Europe/Amsterdam', // Netherlands
  'Europe/Warsaw', // Poland
  'Europe/Lisbon', // Portugal
  'Europe/Bucharest', // Romania
  'Europe/Bratislava', // Slovakia
  'Europe/Ljubljana', // Slovenia
  'Europe/Madrid', // Spain
  'Europe/Stockholm', // Sweden

  // EEA Countries
  'Europe/Oslo', // Norway
  'Atlantic/Reykjavik', // Iceland
  'Europe/Vaduz', // Liechtenstein
  'Europe/Zurich', // Switzerland

  'Europe/London', // United Kingdom
  'Atlantic/Bermuda',
  'Atlantic/Stanley',
  'Atlantic/South_Georgia',
  'Atlantic/St_Helena',
  'Indian/Chagos',
  'America/Cayman',
  'Europe/Gibraltar',
  'America/Montserrat',
  'Pacific/Pitcairn',
  'Atlantic/St_Helena',
  'Atlantic/South_Georgia',
  'America/Grand_Turk',
  'Europe/Guernsey',
  'Europe/Jersey',
  'Europe/Isle_of_Man'
]
